// @flow
import { titleToSlug } from '../../../services/titleToSlug'
import { numberToCurrency } from '../../../services/numberToCurrency'
import catalogMedia from './assets/catalog'

export default {
  productID: 'hardCoded.productID.volldammCup',
  title: 'hardCoded.title.volldammCup',
  slug: titleToSlug('hardCoded.title.volldammCup'),
  catalog: {
    title: 'hardCoded.catalog.title.volldammCup',
    catalogMedia,
    price: numberToCurrency('15'),
    color: '#025343'
  }
}
